import { render, staticRenderFns } from "./FixedAsset.vue?vue&type=template&id=6297d6a0"
import script from "./FixedAsset.vue?vue&type=script&lang=js"
export * from "./FixedAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports